/* eslint-disable */
import { defineStore } from 'pinia';
import { IOrganization, IUser, IWorkflowV2 } from '@rready/sdk';

export interface IApplicationScope {
  user: IUser;
  roles: string[];
  actions: string[];
  organization: IOrganization;
  products: IWorkflowV2[];
}

/**
 * Doesn't do anything, commented getters to prevent access
 * The idea is loading all that is possible right from the start (in App.vue)
 * and make sure nothing is null/undefined, so we can access the main stores
 * safely without being defensive.
 * Also most checks regarding app/related data can be sync
 */
export const useApplicationScopeStore = defineStore('scope', {
  state: () => ({
    userData: undefined! as IUser,
    actionsData: [] as string[],
    organizationData: undefined! as IOrganization,
    productsData: [] as IWorkflowV2[]
  }),
  getters: {
    // user: (state) => {
    //   return state.userData;
    // },
    // actions: (state) => {
    //   return state.actionsData;
    // },
    // organization: (state) => {
    //   return state.organizationData;
    // },
    // Ok, I'll use at least this one
    products: (state) => {
      return state.productsData;
    }
  },
  actions: {
    setup(scope: IApplicationScope) {
      this.userData = scope.user;
      this.actionsData = scope.actions;
      this.organizationData = scope.organization;
      this.productsData = scope.products;
    }
  }
});
